// File: src/components/DemoAISummary.jsx
import React from 'react';
import { motion } from 'framer-motion';

export default function DemoAISummary({ title = '', value = '', trend = '' }) {
  if (!title || !value || !trend) return null;

  const isPositive = trend.trim().startsWith('+');
  const trendColor = isPositive ? 'text-green-400' : 'text-red-400';
  const bgGlow = isPositive ? 'shadow-green-500/40' : 'shadow-red-500/40';

  return (
    <motion.div
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className={`rounded-2xl p-5 bg-[#0f172a] border border-[#334155] shadow-lg ${bgGlow} hover:scale-[1.02] transition-transform duration-300`}
    >
      <h3 className="text-base text-gray-400 mb-1 font-medium tracking-wide">{title}</h3>
      <div className="flex items-center justify-between">
        <p className="text-3xl font-bold text-white">{value}</p>
        <span className={`text-sm font-medium ${trendColor}`}>{trend}</span>
      </div>
      <p className={`text-xs mt-1 ${trendColor}`}>compared to previous</p>
    </motion.div>
  );
}
